import Grid from '@mui/material/Grid';

import WeeklySalesReportChart from './chart-component';
import WeeklySalesReportTable from './table-component';

const WeeklySalesReportContent = (props) => {
  return (
    <Grid item size={{ xs: 12 }}>
      <Grid container mt={7}>
        <Grid item size={{ xs: 12, md: 12 }}>
          <WeeklySalesReportChart props={props} />
        </Grid>
        <Grid item size={{ xs: 12, md: 12 }}>
          <WeeklySalesReportTable props={props} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WeeklySalesReportContent;
